import { render, staticRenderFns } from "./FGlistInfo.vue?vue&type=template&id=32ef3ca0&"
import script from "./FGlistInfo.vue?vue&type=script&lang=js&"
export * from "./FGlistInfo.vue?vue&type=script&lang=js&"
import style0 from "./FGlistInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports